import { render } from "./metaMask.vue?vue&type=template&id=4803877a&scoped=true"
import script from "./metaMask.vue?vue&type=script&lang=js"
export * from "./metaMask.vue?vue&type=script&lang=js"

import "./metaMask.vue?vue&type=style&index=0&id=4803877a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4803877a"]])

export default __exports__